import * as types from '../constants/officeRunnerConstants'

const initialState = {
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_content: null,
  utm_term: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SAVE_UTM_PARAMS:
      return action.utm
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/utmReducer.js